
import React from 'react';
import { createPortal } from 'react-dom';

// Reusable Spinner component with optional portal rendering
const Spinner = ({ isLoading, fullScreen = true, message = "Processing request..." }) => {
  // If not loading, don't render anything
  if (!isLoading) return null;

  // The spinner content JSX
  const spinnerContent = (
    <div
      style={{
        position: fullScreen ? 'fixed' : 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(255, 255, 255, 0.7)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999
      }}
    >
      <div className="text-center">
        <div className="spinner-border text-primary" style={{ width: '3rem', height: '3rem' }} role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <div className="mt-3 fw-bold">{message}</div>
      </div>
    </div>
  );

  // Use createPortal for fullScreen mode to ensure the spinner is rendered at the document level
  return fullScreen 
    ? createPortal(spinnerContent, document.body)
    : spinnerContent;
};

export default Spinner;
